import { render, staticRenderFns } from "./clientVersion.vue?vue&type=template&id=53408e84"
import script from "./clientVersion.vue?vue&type=script&lang=js"
export * from "./clientVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports